import { render, staticRenderFns } from "./LabellingTool.vue?vue&type=template&id=71ac2e8e&"
import script from "./LabellingTool.vue?vue&type=script&lang=js&"
export * from "./LabellingTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports